export default {
  noteTemplates: {},
  loadedNoteTemplates: {}
}
